var ParticleInitialColorNode = (function () {
    function ParticleInitialColorNode() {
    }
    return ParticleInitialColorNode;
}());
export { ParticleInitialColorNode };
